import React, { use } from 'react';

import FixedImage from 'src/components/common/fixed-image';
import DavidLloydLogo from 'src/components/icons/david-lloyd-logo';
import DavidLloydLogoNew from 'src/components/icons/david-lloyd-logo-new';
import { SiteContext } from 'src/context/site-context';
import useShouldUseNewLogo from 'src/custom-hooks/use-should-use-new-logo';
import { BuildType } from 'src/enums/build/build-type';
import {
  darkBgMeridianLogoImage,
  davidLloydLogoImage,
  harbourLogoImage,
  togetherFoundationLogoImage,
} from 'src/helpers/fixed-images/logo-images';

import * as styles from './header-logo.module.scss';

type HeaderLogoProps = {
  davidLloydSize: string;
  meridianSize: string;
  harbourSize: string;
  togetherFoundationSize: string;
};

const getLogoParams = (
  buildType: BuildType,
  davidLloydSize: string,
  meridianSize: string,
  harbourSize: string,
  togetherFoundationSize: string
) => {
  switch (buildType) {
    case BuildType.MERIDIAN:
      return {
        imageDetails: darkBgMeridianLogoImage,
        size: meridianSize,
      };
    case BuildType.HARBOUR:
      return {
        imageDetails: harbourLogoImage,
        size: harbourSize,
      };
    case BuildType.TOGETHER_FOUNDATION:
      return {
        imageDetails: togetherFoundationLogoImage,
        size: togetherFoundationSize,
      };
    default: {
      return {
        imageDetails: davidLloydLogoImage,
        size: davidLloydSize,
      };
    }
  }
};

const HeaderLogo = ({
  davidLloydSize,
  meridianSize,
  harbourSize,
  togetherFoundationSize,
}: HeaderLogoProps) => {
  const { buildType, isDL } = use(SiteContext);
  const shouldUseNewLogo = useShouldUseNewLogo();
  const params = getLogoParams(
    buildType,
    davidLloydSize,
    meridianSize,
    harbourSize,
    togetherFoundationSize
  );

  if (!isDL) {
    return (
      <div className={styles.logoWrapper} style={{ width: params.size }}>
        <FixedImage imageDetails={params.imageDetails} />
      </div>
    );
  }

  return shouldUseNewLogo ? (
    <DavidLloydLogoNew size={davidLloydSize} />
  ) : (
    <DavidLloydLogo size={davidLloydSize} />
  );
};

export { HeaderLogo };
